export const MS_IN_HALF_AN_HOUR = 30 * 60 * 1000;
export const APPT_USER_PATH_STEP_STORAGE_NAME = 'apptUserPathStep';
